module.exports = __webpack_public_path__ + "img/inplay.28cc8aec.jpg";